export default __webpack_public_path__ + "c435c1245edb2bf9d866c6c55445c8c1.jpg";